import React, { Fragment } from 'react';
import Translated from '../../../../base/elements/Translated';
import CustomItemForm from './CustomItemForm';

const CustomItemAdd = ({
  handleClose, handleAddItem, handleSuccess,
}) => (
  <Fragment>
    <header className="modal-card-head">
      <p className="modal-card-title">
        <Translated k="pages.back.orders.details.cart.add" />
      </p>
      <button type="button" className="delete" aria-label="close" onClick={handleClose} />
    </header>
    <CustomItemForm
      onCancel={handleClose}
      onConfirm={(item) => {
        handleAddItem(item);
        handleSuccess();
        handleClose();
      }}
    />
  </Fragment>
);

export default CustomItemAdd;
